import { RfUiInput } from 'renfe-components';

export const FilterContainer = ({
  title,
  valueFilter,
  handleFilterChange,
}) => {
  return (
    <div className="rf-practice-detail__input-container--padding-right">
      <h2 className="rf-title rf-title--secundary">{title}</h2>
      <div className="rf-practice-detail__input-container">
        <RfUiInput
          label={title}
          className="rf-input"
          error=""
          value={valueFilter}
          onValueChanges={(e) => handleFilterChange(e.detail ?? '')}
        ></RfUiInput>
      </div>
    </div>
  );
};
